import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import EarningBreakdownTrend from '../../common/earningBreakdown/Trend'
import {
  getNoDataComponent,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import { changeChecked, selectChecked } from '../../store/slice'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

export const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const checkboxs = [
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA304'),
      color: '#006AA6',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA305'),
      color: '#74B49A',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA306'),
      color: '#B3CC85',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA311'),
      color: '#00A8B5',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA314'),
      color: '#0553A5',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA317'),
      color: '#4EB1CB',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA323'),
      color: '#1D5563',
      group: 1,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA307'),
      color: '#F49966',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA308'),
      color: '#F5CBA3',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA309'),
      color: '#E3A2A7',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA310'),
      color: '#FF596A',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA312'),
      color: '#D96383',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA315'),
      color: '#FFCD60',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA322'),
      color: '#AE93E1',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA321'),
      color: '#717ECD',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA318'),
      color: '#283271',
      group: 2,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'FA320'),
      color: '#D4A7D7',
      group: 3,
    },
  ]

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (isNoData) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <EarningBreakdownTrend
      id={id}
      data={dataByTrend}
      indicatorById={indicatorById}
      isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
      checkboxs={checkboxs.filter((item) => item.title)}
      checked={checked}
      setChecked={setChecked}
      isDynamicReport={isDynamicReport || isDownloadComponent}
    />
  )
}
